"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.zodIssuesToStrings = zodIssuesToStrings;
var z = _interopRequireWildcard(require("zod"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function zodIssuePathToText(zodIssuePath) {
  return zodIssuePath.length > 0 ? ` at path "${zodIssuePath.join('.')}"` : '';
}
function zodIssueToString(zodIssue) {
  if (zodIssue.code === z.ZodIssueCode.invalid_type) {
    return `Expected "${zodIssue.expected}" but received "${zodIssue.received}"${zodIssuePathToText(zodIssue.path)}`;
  }
  if (zodIssue.code === z.ZodIssueCode.unrecognized_keys) {
    return `Unrecognized ${zodIssue.keys.length >= 2 ? 'keys' : 'key'} ${zodIssue.keys.map(key => `"${key}"`).join(', ')}${zodIssuePathToText(zodIssue.path)}`;
  }
  if (zodIssue.code === z.ZodIssueCode.invalid_union) {
    return `Invalid union: ${zodIssue.unionErrors.map(unionError => unionError.issues.map(issue => {
      const zodIssueString = [...zodIssueToString(issue)];
      if (zodIssueString[0]) {
        zodIssueString[0] = zodIssueString[0].toLowerCase();
      }
      return zodIssueString.join('');
    }).join(', ')).join('; ')}`;
  }
  if (zodIssue.code === 'invalid_enum_value') {
    return `Expected ${zodIssue.options.length === 1 ? `"${zodIssue.options[0]}"` : `${zodIssue.options.map(option => `"${option}"`).slice(0, -1).join(', ')} or "${zodIssue.options[zodIssue.options.length - 1]}"`}${zodIssuePathToText(zodIssue.path)}`;
  }
  return `${zodIssue.message}${zodIssuePathToText(zodIssue.path)}`;
}
function zodIssuesToStrings(zodIssues) {
  return zodIssues.map(zodIssue => zodIssueToString(zodIssue));
}
//# sourceMappingURL=zodIssuesToString.js.map